import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const logoImg = "https://customer-assets.emergentagent.com/job_create-snap/artifacts/cv5445ar_image_transparent_original.png";

export const Footer = () => {
  return (
    <footer className="border-t border-[#3B9EFF]/15 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo size="md" testId="footer-logo" />
          <p className="mt-4 text-[#A0AABF] max-w-md leading-relaxed">
            We make it. You post it. You grow. Done-for-you content for small businesses that
            don't have time to babysit social media.
          </p>
          <div className="mt-6 p-3 inline-flex items-center gap-3 rounded-md bg-white/[0.03] border border-[#3B9EFF]/15">
            <img
              src={logoImg}
              alt="ContentSnap"
              className="h-7 w-auto"
              style={{ filter: "invert(1) hue-rotate(180deg) saturate(2)" }}
            />
            <span className="text-xs text-[#A0AABF] font-accent">brand mark</span>
          </div>
        </div>
        <div>
          <h4 className="font-display text-white text-sm uppercase tracking-wider mb-4">
            Offers
          </h4>
          <ul className="space-y-2 text-[#A0AABF]">
            <li><Link to="/offer/pack-99" className="hover:text-[#3B9EFF]" data-testid="footer-link-99">$99.99 Pack</Link></li>
            <li><Link to="/offer/monthly-175" className="hover:text-[#3B9EFF]" data-testid="footer-link-175">$175/mo Plan</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-white text-sm uppercase tracking-wider mb-4">
            Company
          </h4>
          <ul className="space-y-2 text-[#A0AABF]">
            <li><Link to="/about" className="hover:text-[#3B9EFF]" data-testid="footer-about">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#3B9EFF]" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-[#3B9EFF]" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-[#3B9EFF]" data-testid="footer-privacy">Privacy</Link></li>
            <li><a href="mailto:contentsnapbrand@gmail.com" className="hover:text-[#3B9EFF]" data-testid="footer-email">contentsnapbrand@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#3B9EFF]/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#A0AABF]">© {new Date().getFullYear()} ContentSnap. All rights reserved.</p>
          <p className="text-xs text-[#A0AABF] font-accent">ContentSnap.co</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
